'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.OptionContext = void 0;

var _react = require('react');

const OptionContext = /*#__PURE__*/ (0, _react.createContext)({
  materials: {},
  meta: {},
  global: {},
  autoParseStyle: true,
  schema: {
    components: [],
    plugins: [],
  },
});
exports.OptionContext = OptionContext;
